export enum Product {
  Tranquilite80 = 'TRA80',
  Tranquilite65 = 'TRA65',
  Securite = 'SEC',
}

export interface ProductInfo {
  code: Product;
  label: string;
  logo: string;
  longName: string;
  name: string;
}

const productInfoMap: ProductInfo[] = [
  {
    code: Product.Tranquilite80,
    label: 'Tranquillité 80',
    logo: 'Tranquillite80',
    longName: 'Assurance Tranquillité 80',
    name: 'Tranquillité 80',
  },
  {
    code: Product.Tranquilite65,
    label: 'Tranquillité 65',
    logo: 'Tranquillite65',
    longName: 'Assurance Tranquillité 65',
    name: 'Tranquillité 65',
  },
  {
    code: Product.Securite,
    label: 'Sécurité',
    logo: 'Securite',
    longName: 'Assurance Sécurité',
    name: 'Sécurité',
  },
];
export const getProductInfo = (
  productCode: string,
): ProductInfo | undefined => {
  return productInfoMap.find((productInfo) => productInfo.code === productCode);
};

export function getProductFromCode(code: string): ProductInfo | undefined {
  const productInfo = productInfoMap.find((product) => product.code === code);
  return productInfo ? productInfo : undefined;
}
